import React from "react";

function DotIcon({ className }) {
  return (
    <svg
      className={`ic ${className}`}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default DotIcon;
